import React from "react";
import { FlexContainer, Heading } from "../../constants/assets/containers";

import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Permission from "../Common/Permission";
import CreateNewElementDialog from "./CreateNewElementDialog";
import ForceCompleteElementDialog from "./ForceCompleteDialog";

const Header = ({ options, tag }) => {
  const allActions = MenuActionsMappings[MenuNames.COMMUNICATION_HUB];

  return (
    <FlexContainer align="flex-start" className="mb-20">
      <Heading>Communication Hub</Heading>
      <div className="actionBar flex items-center justify-end">
        <Permission requiredPerms={[allActions.COMMUNICATION_HUB_FORCE_COMPLETE]}>
          <ForceCompleteElementDialog options={options} tag={tag} />
        </Permission>
        <Permission requiredPerms={[allActions.COMMUNICATION_HUB_CREATE]}>
          <CreateNewElementDialog options={options} tag={tag} />
        </Permission>
      </div>
    </FlexContainer>
  );
};

export default Header;
